module.exports = __webpack_public_path__ + "img/product_10.3150a94.svg";